(function($) {
  $(document).ready(function() {
    const setCardsHeight = (selector) => {
      $(selector).each(function(index) {
        const cards = $(this).find(".card");
        // Fihnd the tallest card
        let tallestCard = 0;
        cards.each(function(index) {
          const cardHeight = $(this).find(".card__title").height();
          if (cardHeight > tallestCard) {
            tallestCard = cardHeight;
          }
        });
  
        // Set all cards to the tallest card
        cards.each(function(index) {
          $(this).find(".card__title").height(tallestCard);
        });
  
      });  
    }
    setCardsHeight(".recentnews__posts");

    $(window).resize(function() {
      setCardsHeight(".recentnews__posts");
    });

  });
})(jQuery);